module.exports = __webpack_public_path__ + "media/images/rails-lts-grafik-2e3099fc447ec177c26cf3be3d93d7ff.svg";